import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '@/lib/api';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setStatus('error'); return; }
    api.get(`/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [params]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="unsubscribe-page">
      <div className="max-w-md w-full text-center">
        {status === 'loading' && <Loader2 className="w-8 h-8 animate-spin text-neutral-400 mx-auto" />}
        {status === 'success' && (
          <>
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-neutral-900 dark:text-white mb-2">Desinscription confirmee</h1>
            <p className="text-neutral-600 dark:text-neutral-400 mb-6">
              Vous ne recevrez plus d'emails automatiques de DestockPro. Vous continuerez a recevoir les emails transactionnels (messages, confirmations).
            </p>
            <Link to="/" className="text-[#F25C05] font-medium hover:underline">Retour a l'accueil</Link>
          </>
        )}
        {status === 'error' && (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h1 className="text-xl font-bold text-neutral-900 dark:text-white mb-2">Lien invalide</h1>
            <p className="text-neutral-600 dark:text-neutral-400 mb-6">
              Ce lien de desinscription est invalide ou a expire. Contactez-nous a contact@destockpro.be.
            </p>
            <Link to="/" className="text-[#F25C05] font-medium hover:underline">Retour a l'accueil</Link>
          </>
        )}
      </div>
    </div>
  );
}
